import devConfig from './development.json'
import prodConfig from './production.json'
import qaConfig from './qa.json'

export default window.__ENV__ === 'PRODUCTION'
  ? prodConfig
  : window.__ENV__ === 'MASTER' 
    ? qaConfig
    : devConfig



// WEBPACK FOOTER //
// ./src/config/index.js